import { API } from "@infra/api";
import type { Branch } from "@domain/CRM/branch";
import type { Company } from "@domain/CRM/company";
import { makeImportSettingsUseCases } from "@app/imports";
import { logger } from "@infra/logger";
import type { IBranches } from "@ports/branches/IBranches";
import type { ICompanies } from "@ports/companies/ICompanies";

const companiesApi: ICompanies = {
	getByFilter: (filter) => API.Data.Companies.get.byFilter(filter) as Promise<Company[]>,
	updatePortalSettings: (id, settings) => API.Data.Companies.update.portalSettings(id, settings),
	updatePortalConfigurationOptions: (id, options) => API.Data.Companies.update.portalConfigurationOptions(id, options),
	updateAgrianOrganizationIds: (id, ids) => API.Data.Companies.update.agrianOrganizationIds(id, ids),
};

const branchesApi: IBranches = {
	getByIds: (ids) => API.Data.Branches.get.byIds(ids) as Promise<Branch[]>,
	updateAgrianOrganizationIds: (id, ids) => API.Data.Branches.update.agrianOrganizationIds(id, ids),
};

export const importSettingsUseCases = makeImportSettingsUseCases({ companiesApi, branchesApi, logger });
